import http from '../http'
const API_URL = "audit-log"

class auditLogAPI {

  async getByCompany(companyID, page) {
    const response = await http(`${API_URL}/company/${companyID}?page=${page}`)
    return response || null
  }

}

export default new auditLogAPI()
